import BaseComponent from '../base/baseComponent';
import analyticsUtils from 'src/scripts/utilities/analyticsUtils';
export default class LeadButton extends BaseComponent {
    constructor(element) {
        super(element);
        this.handleClick();
    }
    handleClick() {
        this._el.addEventListener('click', async (e) => {
            e.preventDefault();
            this.leadUrl = this._el.getAttribute('href');
            this.pid = this._el.getAttribute('data-pid');
            this.ctaText = this._el.textContent;
            await this.analyticsProductAction();
        });
    }
    async analyticsProductAction() {
        let data = {
            'forcedPipeline': 'ProductAction',
            'pid': this.pid,
            'ctaText': this.ctaText
        };
        analyticsUtils.passThroughProcessor(data, () => { window.location.href = this.leadUrl; });
    }
}
